import { render, staticRenderFns } from "./cancelQuotation.vue?vue&type=template&id=63b3e1d1&scoped=true&"
import script from "./cancelQuotation.vue?vue&type=script&lang=js&"
export * from "./cancelQuotation.vue?vue&type=script&lang=js&"
import style0 from "./cancelQuotation.vue?vue&type=style&index=0&id=63b3e1d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b3e1d1",
  null
  
)

export default component.exports